<template>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline">
          Złóż zamówienie
        </v-card-title>
        <v-card-text>
          <v-form
              ref="newForm"
              v-model="valid"
              lazy-validation
              class="dimension--form mt-5 mb-5"
          >
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-autocomplete
                    v-model="supervisor"
                    :items="supervisors"
                    item-value="id"
                    item-text="email"
                    label="Opiekun zamówienia"
                >
                  <template v-slot:selection="data">
                    {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                  </template>
                  <template v-slot:item="data">
                    {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-text-field
                    v-model="form.phone"
                    :rules="formRules.phone"
                    class="pt-0"
                    type="text"
                    label="Telefon"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-text-field
                    v-model="form.email"
                    :rules="formRules.email"
                    class="pt-0"
                    type="email"
                    label="E-mail"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-text-field
                    v-model="form.street"
                    class="pt-0"
                    type="text"
                    label="Ulica, numer domu i numer lokalu"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" md="4" align-self="start" dense>
                <v-text-field
                    v-model="form.postCode"
                    :rules="formRules.postCode"
                    class="pt-0"
                    type="text"
                    label="Kod pocztowy"
                ></v-text-field>
              </v-col>
              <v-col cols="8" md="8" align-self="start" dense>
                <v-text-field
                    v-model="form.city"
                    :rules="formRules.city"
                    class="pt-0"
                    type="text"
                    label="Miasto"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-text-field
                    v-model="form.quantity"
                    :rules="formRules.quantity"
                    class="pt-0"
                    type="text"
                    :label="(service.type.topCategoryId === 204 ? 'Ile kontenerów zamawiasz' : 'Ilość odpadu') + ' (' + service.unit + ')'"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense v-if="service.type.topCategoryId === 204">
                <v-menu
                    v-model="containerDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="form.containerDate"
                        readonly
                        :disabled="service.type.topCategoryId !== 204"
                        label="Kiedy postawić kontener"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="form.containerDate"
                      @input="containerDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6" align-self="start" dense>
                <v-select
                    v-model="form.paymentType"
                    class="pt-0"
                    type="text"
                    label="Wybierz formę płatności"
                    :items="paymentValues"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-textarea
                    v-model="form.driverInfo"
                    class="pt-0"
                    label="Informacje dla kierowcy"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row v-for="field in service.additionalFields" :key="field">
              <v-col cols="12" md="12" align-self="start" dense>
                <v-text-field
                    v-if="field.type === 'input'"
                    v-model="form[field.name]"
                    class="pt-0"
                    type="text"
                    :label="field.name"
                ></v-text-field>
                <v-select
                    v-if="field.type === 'select'"
                    v-model="form[field.name]"
                    class="pt-0"
                    type="text"
                    :label="field.name"
                    :items="field.options"
                ></v-select>
                <v-menu
                    v-if="field.type === 'datetime'"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="form[field.name]"
                        readonly
                        :label="field.name"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="form[field.name]"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  @click.prevent="onSubmit"
                  type="Submit"
                  class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                  :disabled="adding"
                  large
              >Zamów&nbsp;<v-icon size="24">mdi-send</v-icon></v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";

export default {
  name: 'ModalNewOrder',
  props: {
    item: {},
  },
  mixins: [
  ],
  created() {
  },
  data() {
    return {
      dialog: false,
      service: null,
      supervisors: [],
      supervisor: null,
      containerDate: false,
      adding: false,
      form: {
        phone: '',
        email: '',
        street: '',
        postCode: '',
        city: '',
        quantity: '',
        containerDate: '',
        paymentType: '',
        driverInfo: '',
      },
      formRules: {
        postCode: [(value) => /^[0-9]{2}-[0-9]{3}$/.test(value) || 'Wpisz poprawny kod pocztowy'],
        city: [(value) => !!value || 'Wpisz miasto'],
        quantity: [(value) => !!value || 'Wpisz ilość'],
        containerDate: [(value) => !!value || 'Wybierz datę'],
        phone: [(value) => !!value || 'Wpisz numer telefonu'],
        email: [(value) => !!value || 'Wpisz adres e-mail'],
      },
      valid: false,
      paymentValues: [
        {value: '', text: 'Wybierz formę płatności'},
        {value: 'cash', text: 'Gotówka'},
        {value: 'transfer', text: 'Przelew'},
      ],
    }
  },
  methods: {
    open(service) {
      this.dialog = true
      this.service = service;
      this.form = {
        phone: '',
        email: '',
        street: '',
        postCode: '',
        city: '',
        quantity: '',
        containerDate: '',
        paymentType: '',
        driverInfo: '',
      };

      this.loadSupervisors();
    },
    async loadSupervisors() {
      const supervisorsResponse = await api.get(`/api/users?role=ROLE_SUPERVISOR`);
      this.supervisors = [{id: 0, email: "Wybierz opiekuna -"}].concat(supervisorsResponse.data.items)
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate() || this.adding) {
        return
      }

      this.adding = true;

      let supervisor = typeof this.supervisor === 'object' && this.supervisor !== null ? this.supervisor.id : this.supervisor;

      if (supervisor === null) {
        supervisor = this.$store.state.user.identity.userId;
      }

      api
          .post('/api/service/' + this.service.id + '/buy',
              {
                withTransport: this.service.availableWithTransport,
                addedAsAdmin: true,
                data: JSON.stringify(this.form),
                supervisor: typeof this.supervisor === 'object' && this.supervisor !== null ? this.supervisor.id : this.supervisor,
              }
          )
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Zamówienie zostało złożone.',
            });
            this.$router.push({name: 'orders'})
          })
          .catch((error) => {
            console.error('Error when adding a redirect:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
            this.adding = false;
          })
    },
  },
}
</script>

<style scoped></style>
